import React from 'react'
import Terminal from '../components/Terminal/Terminal'
import { PAGE_TO_COMMANDS } from '../components/Terminal/sessionConfig'

const TerminalPage = ({ match }) => {
    const page = match && match.params ? match.params.page : undefined
    const initialCommands = PAGE_TO_COMMANDS[page] || []

    return <Terminal initialCommands={initialCommands} />
}

export default TerminalPage
